import { TagUsersDynamicCardShared } from '@scale/genai-compass-shared/cards/tag_users_dynamic';
import { makeAutoOpsCardUI } from '../constants';
import { faUserTag } from '@fortawesome/pro-solid-svg-icons';

export const TagUsersDynamicCardUI = makeAutoOpsCardUI(TagUsersDynamicCardShared, {
  button: { icon: faUserTag },
  title: 'Tag Users (Dynamic)',
  toolTip: 'Dynamically tag users with tag ids from table rows.',
  isLegacy: true,
  ownerTeam: 'Pay / Growth',
});
